let provider, signer, account;
// Sepolia testnet addresses
const WETHAddress = "0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9";
const USDCAddress = "0xf08A50178dfcDe18524640EA6618a1f965821715";
const UNIAddress = "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984";
// ERC20 ABI (only including balanceOf function)
const ERC20ABI = [
    {
        "constant": true,
        "inputs": [
            {
                "name": "_owner",
                "type": "address"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "name": "balance",
                "type": "uint256"
            }
        ],
        "type": "function"
    }
];
const connectButton = document.getElementById("connectButton");
const swapButton = document.getElementById("swapButton");
const accountArea = document.getElementById("accountArea");
const ethBalanceArea = document.getElementById("ethBalanceArea");
const wethBalanceArea = document.getElementById("wethBalanceArea");
const usdcBalanceArea = document.getElementById("usdcBalanceArea");
const uniBalanceArea = document.getElementById("uniBalanceArea");
const statusElement = document.getElementById("status");
connectButton.addEventListener("click", connectMetaMask);
swapButton.addEventListener("click", performSwap);
async function connectMetaMask() {
    if (typeof window.ethereum !== "undefined") try {
        await window.ethereum.request({
            method: "eth_requestAccounts"
        });
        provider = new ethers.providers.Web3Provider(window.ethereum);
        signer = provider.getSigner();
        account = await signer.getAddress();
        accountArea.textContent = `Connected Account: ${account}`;
        const network = await provider.getNetwork();
        if (network.chainId !== 11155111) {
            statusElement.textContent = "Please switch to Sepolia network in MetaMask";
            return;
        }
        await updateAllBalances();
        swapButton.disabled = false;
        connectButton.disabled = true;
    } catch (error) {
        console.error("Failed to connect to MetaMask:", error);
        statusElement.textContent = "Failed to connect to MetaMask";
    }
    else statusElement.textContent = "Please install MetaMask!";
}
async function updateAllBalances() {
    if (provider && account) try {
        const [ethBalance, wethBalance, usdcBalance, uniBalance] = await Promise.all([
            provider.getBalance(account),
            getTokenBalance(WETHAddress, 18),
            getTokenBalance(USDCAddress, 6),
            getTokenBalance(UNIAddress, 18)
        ]);
        ethBalanceArea.textContent = `ETH Balance: ${ethers.utils.formatEther(ethBalance)} ETH`;
        wethBalanceArea.textContent = `WETH Balance: ${wethBalance} WETH`;
        usdcBalanceArea.textContent = `USDC Balance: ${usdcBalance} USDC`;
        uniBalanceArea.textContent = `UNI Balance: ${uniBalance} UNI`;
    } catch (error) {
        console.error("Error updating balances:", error);
        statusElement.textContent = "Error updating balances";
    }
}
async function getTokenBalance(tokenAddress, decimals) {
    const contract = new ethers.Contract(tokenAddress, ERC20ABI, provider);
    const balance = await contract.balanceOf(account);
    return ethers.utils.formatUnits(balance, decimals);
}
async function performSwap() {
    statusElement.textContent = "Performing swap...";
    try {
        const response = await fetch("/swap", {
            method: "POST"
        });
        const result = await response.json();
        if (result.success) {
            statusElement.textContent = "Swap successful!";
            await updateAllBalances(); // Update all balances after successful swap
        } else statusElement.textContent = "Swap failed: " + result.error;
    } catch (error) {
        console.error("Error performing swap:", error);
        statusElement.textContent = "Error performing swap";
    }
}
// Check if MetaMask is already connected
if (typeof window.ethereum !== "undefined") window.ethereum.request({
    method: "eth_accounts"
}).then((accounts)=>{
    if (accounts.length > 0) connectMetaMask();
});
// Listen for account changes
if (typeof window.ethereum !== "undefined") window.ethereum.on("accountsChanged", connectMetaMask);

//# sourceMappingURL=index.da6d8772.js.map
